import { render } from "./TitleDesc.vue?vue&type=template&id=9f231d60"
import script from "./TitleDesc.vue?vue&type=script&lang=js"
export * from "./TitleDesc.vue?vue&type=script&lang=js"

import "./TitleDesc.vue?vue&type=style&index=0&id=9f231d60&lang=scss"

import exportComponent from "D:\\git\\tim\\tim-sign-ui_imza.ebirlik.net\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__